export enum PayrollResultType {
    CostCenter = 'cost',
    PayrollResult = 'payr',
}



// WEBPACK FOOTER //
// ./src/app/shared/_utils/services/PayrollResultType.enum.ts